import React from 'react'
import EstablishmentCreateView from './establishmentCreateView'
import SignUpContent from 'components/layouts/components/signUpContent'
import SignUpActions from 'components/layouts/components/signUpActions'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import { Typography } from '@material-ui/core'
import { Trans } from 'react-i18next'
import LocationForm, { LocationFormState } from 'components/forms/establishment/locationForm'

interface Props {
    step: number
    steps: number
    onSubmit: (values: LocationFormState) => void
    inProgress: boolean
    initialValues: LocationFormState
    onPrevious: () => void
    previousInProgress: boolean
}

const EstablishmentLocationView: React.FC<Props> = ({
    step,
    steps,
    onPrevious,
    previousInProgress,
    inProgress,
    ...formData
}) => {
    const classes = useStyles()

    return (
        <LocationForm inProgress={inProgress} {...formData}>
            {(content, actions) => (
                <>
                    <SignUpContent>
                        <EstablishmentCreateView step={step} steps={steps}>
                            <Typography variant="h1" color="textSecondary" className={classes.title}>
                                <Trans i18nKey="views.establishment.location.title" />
                            </Typography>
                            <Typography variant="h2" color="textSecondary" className={classes.subtitle}>
                                <Trans i18nKey="views.establishment.location.subtitle" />
                            </Typography>
                            {content}
                        </EstablishmentCreateView>
                    </SignUpContent>
                    <SignUpActions>
                        <SubmitButton
                            variant="contained"
                            onClick={onPrevious}
                            loading={previousInProgress}
                            disabled={inProgress}
                        >
                            <Trans i18nKey="actions.previous" />
                        </SubmitButton>

                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                disabled={previousInProgress}
                                {...action}
                                className={clsx(action.className)}
                            />
                        ))}
                    </SignUpActions>
                </>
            )}
        </LocationForm>
    )
}

export default EstablishmentLocationView
